import React from 'react';
import { SupplierFormModalView } from './SupplierFormModalView';
import {
    useSupplierForm,
    type SupplierFormInitialValues,
    type SupplierFormSubmit,
} from './useSupplierForm';

type SupplierFormModalProps = {
    error: string | null;
    initialValues: SupplierFormInitialValues | null;
    isOpen: boolean;
    isSubmitting: boolean;
    mode: 'create' | 'edit';
    onClose: () => void;
    onSubmit: (input: SupplierFormSubmit) => void;
};

/**
 * Container for the Add / Edit Supplier modal: instantiates the form-state hook
 * and hands its output (plus the modal-chrome props) to the render-only View.
 */
export const SupplierFormModal: React.FC<SupplierFormModalProps> = ({
    error,
    initialValues,
    isOpen,
    isSubmitting,
    mode,
    onClose,
    onSubmit,
}) => {
    const form = useSupplierForm({
        initialValues: initialValues ?? undefined,
        isOpen,
        onSubmit,
    });

    return (
        <SupplierFormModalView
            error={error}
            form={form}
            isOpen={isOpen}
            isSubmitting={isSubmitting}
            mode={mode}
            onClose={onClose}
        />
    );
};
